var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SlideOut',{ref:"slideOut",attrs:{"is-loading":_vm.isLoading},on:{"on-submit":_vm.onSubmit}},[_c('OrdersReworkProperties',{ref:"ordersReworkPropertiesUpdate",attrs:{"rework-properties":_vm.propertiesToUpdate,"hide-actions":""},on:{"edit-property-by-id":_vm.editProperties}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }